module.exports = __webpack_public_path__ + "img/invoiceBackAct.fab749d3.png";